import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  id: string;
  variant?: "solid" | "outline";
}

export default function FavoriteButton({ id, variant = "solid" }: FavoriteButtonProps) {
  const { toggle, isFavorite } = useFavorites();
  const active = isFavorite(id);

  const base =
    "flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2.5 text-sm font-label transition-colors duration-200";
  const style = active
    ? "bg-primary-500 text-background-50 hover:bg-primary-600"
    : variant === "solid"
      ? "border border-background-300/70 bg-background-100/70 text-foreground-700 hover:border-primary-500/60 hover:text-primary-400"
      : "border border-accent-500/60 text-accent-400 hover:bg-accent-500/10";

  return (
    <button
      type="button"
      onClick={() => toggle(id)}
      aria-pressed={active}
      className={`${base} ${style} cursor-pointer`}
    >
      <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"} />
      {active ? "已收藏" : "收藏"}
    </button>
  );
}